import { Pipe, PipeTransform } from '@angular/core';

export type Separator = ' ' | ', ' | '_' | ' _ ' | ' - ' | ';' | ' ; ' | '|' | ' | ';

export function acJoin(input: string | number | Array<string | number | null | undefined>, separator: Separator = ' '): string {
  const inputArray = Array.isArray(input) ? input.filter((value) => value != null).map((value) => String(value)) : [String(input)];
  return inputArray.join(separator);
}

@Pipe({
  name: 'acJoin',
  standalone: true,
})
export class JoinPipe implements PipeTransform {
  transform(input: string | number | Array<string | number | null | undefined>, separator: Separator = ' '): string {
    return acJoin(input, separator);
  }
}
